import Component from 'flarum/common/Component';
export default class Hero extends Component {
  view() {
    const title = this.attrs.title;
    const subtitle = this.attrs.subtitle;
    delete this.attrs.title;
    delete this.attrs.subtitle;
    this.attrs.className = 'Hero ' + (this.attrs.className || '');
    return m("header", this.attrs, m("div", {
      className: "container"
    }, m("div", {
      className: "containerNarrow"
    }, m("h2", {
      className: "Hero-title"
    }, title), m("div", {
      className: "Hero-subtitle"
    }, subtitle))));
  }
}
flarum.reg.add('sycho-github-milestone', 'forum/components/Hero', Hero);